<template>
  <div class="detail-wrap">
    <el-form ref="editForm" :model="formData">
      <div class="d-header clearfix">
        <div class="fl">
          <i class="el-icon-info"/>
          {{ dataId ? '查看' : '新增' }}仓库设置
        </div>
        <div class="fr">
          <!--          <el-button type="primary" plain class="button-sty" @click="$baseReload()" icon="el-icon-refresh-right">重置-->
          <!--          </el-button>-->
          <el-button type="primary" class="button-sty" icon="el-icon-check"
                     v-if="(warehouse_edit && formData.id != null) || (warehouse_add && formData.id == null)"
                     @click="saveData">保存</el-button>
        </div>
      </div>
      <div>

        <!-- 品牌信息 -->
        <div class="d-cont edit-mce-box">
          <div class="d-item">
            <div class="title first">
              <b>主信息</b>
            </div>
            <table class="table-detail">
              <tbody>
              <tr>
                <th>
                  <em class="f-red">*</em>
                  仓库编码
                </th>
                <td>
                  <el-input type="text" autocomplete="off" v-model="formData.warehouseCode" @blur="inspection" clearable/>
                </td>
                <th>
                  <em class="f-red">*</em>
                  仓库名称
                </th>
                <td>
                  <el-input type="text" autocomplete="off" v-model="formData.warehouseName" clearable/>
                </td>
                <th>
                  <em class="f-red">*</em>
                  仓库类型
                </th>
                <td v-if="formData.warehouseType==3">网点仓</td>
                <td v-else>
                  <el-select v-model="formData.warehouseType">
                    <el-option label="总部仓" :value="0"/>
                    <el-option label="机构仓" :value="1"/>
                    <el-option label="代理仓" :value="2"/>
                  </el-select>
                </td>
                <th>
                  配件代理网点
                </th>
                <td>
                  <el-input type="text" autocomplete="off" v-model="formData.proxySiteName"
                            :disabled="formData.warehouseType !== 2" clearable>
                    <i slot="suffix" class="el-input__icon el-icon-search"
                       @click="showSiteDialog2 "></i>
                  </el-input>
                </td>
              </tr>
              <tr>
                <th>
                  <em class="f-red">*</em>
                  是否配件仓
                </th>
                <td>
                  <el-radio v-model="formData.isPartsWare" :label="0">否</el-radio>
                  <el-radio v-model="formData.isPartsWare" :label="1">是</el-radio>
                </td>
                <th>
                  <em class="f-red">*</em>
                  是否产品仓
                </th>
                <td>
                  <el-radio v-model="formData.isItemWare" :label="0">否</el-radio>
                  <el-radio v-model="formData.isItemWare" :label="1">是</el-radio>
                </td>
                <th>
                  库存是否对网点开放
                </th>
                <td>
                  <el-radio v-model="formData.isPublic" :label="0">否</el-radio>
                  <el-radio v-model="formData.isPublic" :label="1">是</el-radio>
                </td>
              </tr>
              <tr>
                <th>
                  <em class="f-red">*</em>
                  是否默认为配件申请出库仓
                </th>
                <td>
                  <el-radio v-model="formData.isOutDefault" :label="0">否</el-radio>
                  <el-radio v-model="formData.isOutDefault" :label="1">是</el-radio>
                </td>
                <th>
                  <em class="f-red">*</em>
                  是否外部对接仓库
                </th>
                <td>
                  <el-radio v-model="formData.isInterfaceWarehouse" :label="0">否</el-radio>
                  <el-radio v-model="formData.isInterfaceWarehouse" :label="1">是</el-radio>
                </td>
                <th>
                  <em class="f-red">*</em>
                  是否为好件返厂入库仓
                </th>
                <td>
                  <el-radio v-model="formData.isGoodReturnDefault" :label="0">否</el-radio>
                  <el-radio v-model="formData.isGoodReturnDefault" :label="1">是</el-radio>
                </td>
                <th>
                  是否为旧件返厂入库仓
                </th>
                <td>
                  <el-radio v-model="formData.isOldReturnDefault" :label="0">否</el-radio>
                  <el-radio v-model="formData.isOldReturnDefault" :label="1">是</el-radio>
                </td>
              </tr>
              <tr>
                <th>
                  限额
                </th>
                <td>
                  <el-input type="text" autocomplete="off" v-model="formData.quota" clearable/>
                </td>
                <th>
                  <em class="f-red">*</em>
                  启用
                </th>
                <td>
                  <el-select v-model="formData.usable">
                    <el-option label="禁用" :value="0"/>
                    <el-option label="启用" :value="1"/>
                  </el-select>
                </td>
              </tr>
              <tr>
                <th>创建人</th>
                <td>{{ formData.createBy }}</td>
                <th>创建时间</th>
                <td>{{ formData.createTime }}</td>
              </tr>
              </tbody>
            </table>
          </div>

          <div class="d-item" style="width: 570px;">
            <div class="title first"
                 style="display: flex;flex-direction: row; justify-content: space-between;">
              <b>关联机构</b>
              <div class="item-button">
                <el-button type="primary" class="button-sty btn_zdy"
                           @click="showOrgDialog = true">
                  <i class="el-icon-plus"></i>
                  添加
                </el-button>&nbsp;
                <el-button
                  type="primary" class="button-sty btn_zdy" @click="handleDelete(selectedData)">
                  <i class="el-icon-delete"></i>
                  批量删除
                </el-button>
              </div>
            </div>
            <div class="current-info">
              <vxe-table ref="filterTable" height="260"
                         class="table_item pic_item mytable-scrollbar"
                         :column-config="{ resizable: true }"
                         style="width: 100%;"
                         :stripe="true"
                         :header-cell-style="{height: '30px',  background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                         :row-config="{height: 30,isHover: true,padding: 0,}"
                         :row-style="{ fontSize: '12px',  }"
                         show-overflow
                         :data="formData.basWarehouseOrgDTOList"
                         @checkbox-all="({records}) => {selectedData = records}"
                         @checkbox-change="({records}) => {selectedData = records}"
              >
                <vxe-column type="checkbox" width="40"/>
                <vxe-column field="orgCode" title="机构编码" width=""/>
                <vxe-column field="orgName" title="机构名称" width=""/>
                <vxe-column title="操作" width="60" v-if="(warehouse_edit && formData.id != null) || (warehouse_add && formData.id == null)">
                  <template #default="{row}">
                    <div @click="handleDelete([row])">
                      <el-tooltip :enterable="false" effect="dark" content="删除" placement="top"
                                  popper-class="tooltip-skin">
                        <i class="el-icon-delete" style="font-size: 18px; color: #00c4b3"></i>
                      </el-tooltip>
                    </div>
                  </template>
                </vxe-column>
              </vxe-table>
            </div>
          </div>
        </div>

      </div>
    </el-form>
    <site-dialog v-if="showSiteDialog" :visiable.sync="showSiteDialog" multi="false" @commit="commitSelectedRow"/>

    <checkbox-org-dialog v-if="showOrgDialog" :visiable.sync="showOrgDialog" @commitOrgSelect="commitOrgSelect"/>
  </div>
</template>
<script>
import {
  initVxeTable
} from '@/const/crud/admin/table';
import Tinymce from '@/components/Tinymce';
import siteDialog from '@/views/dialogCommon/radioSiteDialog.vue';
import api from "@/api/projectApi";
import {mapGetters} from "vuex";
import {editPageMixins} from "@/mixins/tabChang";
import CheckboxOrgDialog from "@/views/dialogCommon/checkboxOrgDialog.vue";

export default {
  mixins: [editPageMixins],
  name: 'edit',
  props: {
    _dataId: [String, Number]
  },
  components: {
    CheckboxOrgDialog,
    Tinymce, siteDialog
  },
  data() {
    return {
      warehouse_edit: false,
      warehouse_add: false,
      showEdit: false,
      activeName: 'first',
      isEdit: false,
      dataId: '',
      getDataUrl: '/basic/basWarehouse/getById',
      addDataUrl: '/basic/basWarehouse/add',
      updateDataUrl: '/basic/basWarehouse/update',
      formData: {
        id: null,
        createTime: '',
        createBy: '',
        warehouseCode: '',  // 仓库编码,同厂商下惟一
        warehouseName: '',  // 仓库名称
        warehouseType: 0,  // 仓库类型：0总部仓、1机构仓、2代理仓、3网点仓（网点仓在创建网点时创建，在新增仓库页面无此选项）
        proxySiteId: '',  // 配件代理网点ID,关联sn_user.id;仓库类型为2时必填
        proxySiteName: null,
        isPartsWare: 1,  // 是否配件仓：0否1是
        isItemWare: 0,  // 是否产品仓：0否1是
        isPublic: 0,  // 库存是否对网点开放:0否1是
        isOutDefault: 0,  // 是否默认为配件申请出库仓：0否1是
        isInterfaceWarehouse: 0,  // 是否外部对接仓库：0否1是;为是时表示对接外部库存
        quota: 0,  // 限额
        isGoodReturnDefault: 0,  // 是否为好件返厂入库仓：0不是，1是
        isOldReturnDefault: 0,  // 是否为旧件返厂入库仓：0不是，1是
        usable: 1,  // 启用:0禁用；1启用

        basWarehouseOrgDTOList: []
      },
      // 基本信息
      tenant: {
        status: 0,
        tenantAttachmentDTOs: []
      },

      selectedData: [],

      showSiteDialog: false,
      showOrgDialog: false,
    };
  },

  computed: {
    ...mapGetters(["permissions"])
  },
  created() {
    this.warehouse_edit = this.permissions['warehouse_edit']
    this.warehouse_add = this.permissions['warehouse_add']

    if (this._dataId && !isNaN(this._dataId)) this.dataId = this._dataId;
  },

  mounted() {
    this.getData();
  },

  methods: {
    commitOrgSelect(data) {
      console.log('机构选中', data)
      if (data && data.length > 0) {
        let temp = this.formData.basWarehouseOrgDTOList
        if (!temp) temp = []
        data.forEach(item => {
          let flag = true
          temp.forEach(i => {
            if (i.orgId == item.id) {
              flag = false
            }
          })

          if (flag) {
            temp.push({orgId: item.id, orgName: item.name, orgCode: item.orgCode})
          }
        })

        this.formData.basWarehouseOrgDTOList = temp
      }
    },

    handleDelete(rowIds) {
      if (!rowIds || rowIds.length === 0) {
        this.$message.error('请先选中数据')
        return
      }
      rowIds.forEach(item => {
        let tempList = this.formData.basWarehouseOrgDTOList
        tempList = tempList.filter(item1 => item1.orgId != item.orgId)
        this.formData.basWarehouseOrgDTOList = tempList
      })
    },

    inspection() {
      if (this.formData.warehouseCode) {
        this.$http({
          url: api.basWarehouse.inspectionUrl,
          method: 'post',
          data: {
            value: this.formData.warehouseCode,
            id: this.formData.id,
          }
        }).then(res => {
          if (!res.data.data) {
            this.$message.warning("仓库编码已存在，请重新输入")
            this.formData.warehouseCode = null
          }
        })
      }
    },

    // selectChangeEvent(data) {
    //   console.log('data', data)
    // },


    showSiteDialog2() {
      if (this.formData.warehouseType == 2) {
        this.showSiteDialog = true
      }
    },
    commitSelectedRow(data) {
      console.log('弹框选中', data)
      this.formData.proxySiteId = data.id
      this.formData.proxySiteName = data.name
    },

    getData() {
      if (this.dataId && !isNaN(this.dataId)) {
        this.isEdit = true;
        this.$http({
          url: this.getDataUrl,
          method: 'post',
          data: {
            id: this.dataId
          },
          isLoading: true,
          modalStrictly: true,
        }).then(response => {
          this.formData = response.data.data
        })
      }
    },

    saveData() {
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.$baseConfirm('您确定要保存吗？').then(() => {
            this.$mask.open()

            this.$http({
              url: this.isEdit ? this.updateDataUrl : this.addDataUrl,
              method: `post`,
              data: this.formData,
              isLoading: true,
            }).then(res => {
              this.$message.success("保存成功！")
              this.goBackIndex()
              this.$mask.close()

              // this.$emit('editViewDataUpdate')
            }).catch(e => {
              console.error(e)
              this.$message.error("保存失败！")
              this.$mask.close()

            })
          });
        }
      });
    },

  },
};

</script>
<style lang="scss" scoped>
::v-deep .vxe-grid .vxe-grid--pager-wrapper {
  display: block;
  width: 100%;
  position: fixed;
  bottom: -38px !important;
  position: absolute !important;
  z-index: 9999999;
  background-color: #ffffff;
}

.btn_zdy {
  // margin: 5px;
  border: 1px solid #dcdfe6 !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
  font-weight: 400;
  text-align: center;
  background-color: #FBFBFB !important;
}

.btn_zdy:hover {
  color: #00c4b3 !important;
  border: 1px solid #00c4b3 !important;
}
</style>
